import { Component, OnInit, ViewChild } from '@angular/core';
import { NavController, NavParams ,ToastController} from 'ionic-angular';

import { ConectorProvider } from "../../providers/conector/conector";
import { GlobalProvider } from "../../providers/global/global";

import { CalendarComponent } from 'ng-fullcalendar';
import { Options } from 'fullcalendar';


import * as moment from 'moment';


@Component({
  selector: 'page-cuadrante-propio',
  templateUrl: 'cuadrante-propio.html',
})
export class CuadrantePropioPage implements OnInit {
  data: any = {};
 
  turnos : any = [];
  licencias : any = [];

  verfecha :any
  calendarOptions: Options;

  tiposlicencia:any = this.global.CONFIGURA["tipos_licencia"];

  ValPersCuadPropio :any = {
    "fechaCuadrante": moment(new Date()).format("DD-MM-YYYY") , 
    
   }
  
  @ViewChild(CalendarComponent) ucCalendar: CalendarComponent;

  constructor(public navCtrl: NavController, public navParams: NavParams,public global: GlobalProvider, public conector:ConectorProvider,private toastCtrl: ToastController) {

    this.data = {
      "background"      : "assets/images/background/39.jpg", 
   };
   

    this.tiposlicencia = this.global.CONFIGURA["tipos_licencia"]

      
    if(this.global.CONFIGURA["ValPersCuadPropio"]){
      this.ValPersCuadPropio = this.global.CONFIGURA["ValPersCuadPropio"]
     
      
      this.loadEvents(this.ValPersCuadPropio.fechaCuadrante )    
      
    } else {
      this.global.CONFIGURA["ValPersCuadPropio"] = this.ValPersCuadPropio
    }

  }
 
  fechatoIso(f,h){
    var ef = f.split("-")
   
    return (ef[2]+"-"+ef[1]+"-"+ef[0]+"T"+h)
  }

  ngOnInit() {

    this.calendarOptions = {
      editable: false,
      eventLimit: false,
      locale:'es',
      height:450,
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'month,agendaWeek,agendaDay,listMonth',
        
      },
      buttonText: {
        today:    'hoy',
        month:    'mes',
        week:     'semana',
        day:      'dia',
        list:     'lista'
      },
      events:[]
    };
    
   console.log("param", this.navParams )

    let fechaParam = this.navParams.data["fecha"]

    console.log("param", fechaParam )
    
    let fechaCuadrante =   this.ValPersCuadPropio.fechaCuadrante
    if( fechaParam ){
      fechaCuadrante = moment(fechaParam,"DD-MM.YYYY").format("DD-MM-YYYY") 
    } 

     
    this.loadEvents(fechaCuadrante )    

     
  
  }

  loadEvents(f){
    this.conector.getcuadrantepropio(f).subscribe(data => {
      // actualizamos eventos
      this.ucCalendar.fullCalendar('removeEvents');

      this.turnos = data["turnos"]
      this.licencias= data["licencias"]

      this.calendarOptions.events=[]

      let Leventos = []

      data["turnos"].forEach( (turno) => {
        //console.log("load turno",turno)
        let evento ={
          title: turno.centro.nombre,				
          start: this.fechatoIso(turno.fecha,turno.horadesde),
          end: this.fechatoIso(turno.fecha,turno.horahasta),
          allDay: false,
          backgroundColor: turno.empleado.color,
          description: turno.horadesde +" a "+ turno.horahasta,
          icon: 'fa-clock-o',
          empleadoid:turno.empleado.id,
          nombrecompleto:turno.empleado.apellidos+", "+turno.empleado.nombre,
          turnoid: turno.id,
          centro: turno.centro.nombre
          
        }
        Leventos.push(evento);//push
              

      });

      this.licencias.forEach( (licencia) => {
        
        licencia.tiponombre = this.tiposlicencia[licencia.tipo]
        
        // fhasta es incluido en las vacaciones , calculamos el dia dia siguiente
        let diaSiguientefHasta =   moment(licencia.fhasta,"DD-MM-YYYY").add(1,"days").format("DD-MM-YYYY")
        
        let evento ={
          title: this.tiposlicencia[licencia.tipo],			
          start: this.fechatoIso(licencia.fdesde,"00:00:00"),
          end: this.fechatoIso(diaSiguientefHasta,"00:00:00"), 
          allDay: true,
          className:['claseLicencia_'+licencia.tipo],
          description: this.tiposlicencia[licencia.tipo] +" de " + licencia.fdesde +" a " + licencia.fhasta,
          
          empleadoid:licencia.empleado.id,
          nombrecompleto:licencia.empleado.apellidos+", "+licencia.empleado.nombre,
          turnoid: null,
          centro: ''
          
        }
        Leventos.push(evento);//push      

      });
      
      this.ucCalendar.fullCalendar('renderEvents',Leventos);
      this.ucCalendar.fullCalendar('gotoDate',this.fechatoIso(this.ValPersCuadPropio.fechaCuadrante,"00:00:00"));
     
    })//Conector
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CuadrantePropioPage');
  }

  ionViewWillEnter(){
    
  }
  
  eventClick(e){
    console.log("eventClick",e)
    let toast = this.toastCtrl.create({
      message: e.event.description + " " + e.event.centro,
      duration: 2000,
      position: 'middle'
    });

    toast.present();

  }

  clickButton(e){
     console.log("clickButton",e.data)
     if(e.buttonType=="prev" ||e.buttonType=="next"||e.buttonType=="today" ){

      this.ValPersCuadPropio.fechaCuadrante = e.data.format("DD-MM-YYYY")
      this.global.CONFIGURA["ValPersCuadPropio"] = this.ValPersCuadPropio
     this.loadEvents(this.ValPersCuadPropio.fechaCuadrante )    
      

     }
  }
  updateEvent(){

  }
  siguiente(){

  }
}



// WEBPACK FOOTER //
// ./src/pages/cuadrante-propio/cuadrante-propio.ts